<template>
  <div
    class="m-auto max-w-md px-6 text-left md:my-4 md:mt-32 md:rounded-md md:border md:border-light-gray md:px-14 md:py-10 md:shadow-primary lg:mt-14"
    :class="customClass"
  >
    <div
      class="-mx-6 mb-6 mt-4 flex justify-center border-b border-light-gray px-6 md:mx-0 md:mb-2 md:mt-0 md:border-0 md:px-0"
    >
      <img
        v-if="showLogo"
        class="mb-6 mt-2 h-6 md:mb-8"
        src="@/assets/highway_logo.svg"
        alt="highway logo"
      />
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Layout',
  props: {
    showLogo: {
      type: Boolean,
      default: true,
    },
    customClass: {
      type: String,
      default: '',
    },
  },
};
</script>
